/* ------------------------------------------------------------------ *
 *  smart-add.js – unified ATC (Custom Cart) → no duplicates,         *
 *                no redirection, always opens the drawer             *
 *                + immediate recalculation of promos                 *
 *                Added by Wilson from Galadrim                       *
 * ------------------------------------------------------------------ */

(() => {
  /* ───────────── 1. helpers ─────────────────────────────────────── */

  /* wait for the Shopify global object to be loaded */
  const whenShopifyReady = cb => (window.Shopify?.routes?.root ? cb() : setTimeout(() => whenShopifyReady(cb), 40));

  /* ───────────── 2. add + (re)calculate promos ───────────────────── */

  async function smartAdd(form) {
    const atcButton = form.querySelector(".product-form--atc-button");

    // Start processing UI
    if (atcButton) {
      atcButton.disabled = true;
      atcButton.classList.add("processing");
    }

    try {
      /* ---- a. form data ---------------------------------- */
      const variantInput = form.querySelector('[name="id"]');
      if (!variantInput?.value) {
        if (atcButton) atcButton.disabled = false;
        return form.submit(); // security
      }

      const variantId = variantInput.value;
      const qtyInput = form.querySelector('[name="quantity"]');
      const qtyToAdd = qtyInput ? +qtyInput.value || 1 : 1;

      /* ---- c. Use Empire theme's cart add pattern -------------------------- */
      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", qtyToAdd);

      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status} from cart API`);
      }

      // Get the updated cart from the response
      const newCart = await response.json();

      /* ---- d. UI updates (from custom-theme.js) -------------------- */
      if (atcButton) {
        atcButton.classList.remove("processing");
        atcButton.classList.remove("added-success");
        void atcButton.offsetWidth;
        atcButton.classList.add("added-success");
        setTimeout(() => {
          atcButton.classList.remove("added-success");
        }, 900);
      }

      if (qtyInput) {
        qtyInput.value = 1;
      }

      if (typeof window.showSuccessToast === "function") window.showSuccessToast();

      // Update header cart badge using Empire theme pattern
      const countEvent = new CustomEvent("cartcount:update", {
        detail: newCart,
      });
      window.dispatchEvent(countEvent);

      if (document.body.classList.contains("template-cart") && typeof window.refreshCartPageSection === "function") {
        window.refreshCartPageSection();
      }

      /* ---- e. open drawer ------------------------ */
      if (typeof window.refreshCartDrawerSection === "function") {
        await window.refreshCartDrawerSection();
      }
      window.openCustomCartDrawer?.();

      // Trigger promo refresh AFTER drawer is opened
      setTimeout(() => {
        document.dispatchEvent(new Event("promos:refresh"));
      }, 100);
    } catch (err) {
      console.error("[SmartAdd] Add to cart failed:", err);
      if (atcButton) {
        atcButton.classList.remove("processing");
      }
      if (typeof window.showFailedToast === "function") {
        window.showFailedToast("Impossible d'ajouter ce produit au panier.");
      }
    } finally {
      if (atcButton) {
        atcButton.disabled = false;
      }
    }
  }

  /* ───────────── 3. hijack all <form[data-product-form]> ─ */
  document.addEventListener(
    "submit",
    ev => {
      const form = ev.target.closest("form[data-product-form]");
      if (!form) return;

      ev.preventDefault();
      ev.stopImmediatePropagation();
      whenShopifyReady(() => smartAdd(form));
    },
    true
  ); // capture=true → before the theme's JS
})();
